<template>
  <ion-card v-if="cartItem" >
    <ion-card-content class="position-relative">
      <ion-button @click="deleteItem" color="danger" class="del_btn"><i class="far fa-trash"></i></ion-button>
      <ion-grid>
        <ion-row>
          <ion-col size="5">
            <img class="img" :src="cartItem.pic_url" alt="">
            <button :disabled="wait_btn" @click="decrement()" class="input-number-decrement">–</button>
            <input :disabled="wait_btn" @change="setCartItem()" class="input-number" type="tel" v-model="cartItem.quantity" >
            <button :disabled="wait_btn" @click="increment()" class="input-number-increment">+</button>
          </ion-col>
          <ion-col size="7">
            <div class="p-info">
              <div class="mb-1">
                <i class="far fa-tag"></i>
                {{cartItem.item_title}}
                <div>{{cartItem.attributes}}</div>
              </div>
              <div v-if="cartItem.provider">
              <div class="mb-1">
                <i class="far fa-store"></i>
                {{cartItem.provider.title}}
              </div>

              <div class="justify-between mb-1">
                <div>قیمت :</div>
                <div>
                  <div v-if="cartItem.percent">
                    <del><money :number="cartItem.original_price"></money></del>
                    <span class="percent">{{cartItem.percent}}%</span>
                  </div>
                  <money :number="cartItem.price"></money>
                  تومان
                </div>
              </div>
              <div class="justify-between mb-1">
                <div>جمع :</div>
                <div>
                  <money :number="cartItem.total"></money>
                  تومان
                </div>
              </div>
              </div>
              <b v-else class="text-success">
                قیمت گذاری بعد از بررسی انجام می شود
              </b>
              <div v-if="cartItem.unit_type === 'big'" class=" text-danger">
                واحد :
                {{cartItem.bigger_unit_title}}
              </div>
              <div v-if="cartItem.unit_type === 'big'" class=" text-danger">
                تعداد در هر {{cartItem.bigger_unit_title}} :
                {{cartItem.bigger_unit_quantity}}
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</template>

<script>
import Money from "@/components/Money";
import {mapActions} from "vuex";
import {showSystemNoti} from "@/shared/helper";
import {alertController} from "@ionic/vue";
export default {
  components:{
    Money
  },
  name: "cartItem",
  methods:{
    ...mapActions("shop", {
      cartItemChangeQuantity: 'cartItemChangeQuantity',
      deleteCartItem : 'deleteCartItem'
    }),
    async decrement()
    {
      const quantity = this.cartItem.quantity;
      if (quantity > 1)
      {
        const id = this.cartItem._id;
        this.wait_btn = true;
        const check = await this.cartItemChangeQuantity({id : id,quantity:quantity-1});
        this.wait_btn = false;
        if (check.ok)
        {
          this.callEmit = true;
          this.cartItem.quantity = check.item.quantity;
          this.cartItem.original_price = check.item.original_price;
          this.cartItem.special_discount = check.item.special_discount;
          this.cartItem.total = check.item.total;
        }
        else
        {
          showSystemNoti('danger',check.msg);
        }
      }
    },
    async increment()
    {
      const quantity = this.cartItem.quantity;
        const id = this.cartItem._id;
      this.wait_btn = true;
        const check = await this.cartItemChangeQuantity({id : id,quantity:quantity+1});
      this.wait_btn = false;
        if (check.ok)
        {
          this.callEmit = true;
          this.cartItem.quantity = check.item.quantity;
          this.cartItem.original_price = check.item.original_price;
          this.cartItem.special_discount = check.item.special_discount;
          this.cartItem.total = check.item.total;
        }
        else
        {
          showSystemNoti('danger',check.msg);
        }
    },
    async deleteItem()
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'سرویس از لیست سرویس های شما حذف شود.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const del = await this.deleteCartItem(this.cartItem._id);
                  if (del.ok)
                  {
                    this.del_item = new Date().getTime();
                  }
                  else
                    return showSystemNoti('danger',del.error)

                },
              },
            ],
          });
      return alert.present();
    },
    async setCartItem(){
      if (!isNaN(this.cartItem.quantity))
      {
        if (this.cartItem.quantity !== '0')
        {
          const id = this.cartItem._id;
          this.wait_btn = true;
          const check = await this.cartItemChangeQuantity({id: id, quantity: this.cartItem.quantity});
          this.wait_btn = false;
          if (check.ok)
          {
            this.callEmit = true;
            this.cartItem.quantity = check.item.quantity;
            this.cartItem.original_price = check.item.original_price;
            this.cartItem.special_discount = check.item.special_discount;
            this.cartItem.total = check.item.total;
          }
          else
          {
            showSystemNoti('danger', check.msg);
            this.cartItem.quantity = this.item.quantity;
          }
        }
        else
          this.cartItem.quantity = this.item.quantity;
      }
      else
      {
        this.cartItem.quantity = this.item.quantity;
      }
    },
  },
  data()
  {
    return {
      callEmit:false,
      cartItem:null,
      wait_btn : false,
      del_item : false,
    }
  },
  watch:{
    item(){
      this.callEmit = false;
      this.cartItem = JSON.parse(JSON.stringify(this.item))
    },
    cartItem: {
      handler: function (cartItem)
      {
        if (this.callEmit)
        {
          this.$emit('itemChanged',cartItem)
          this.callEmit=false;
        }
      },
      deep: true
    },
    del_item:{
      handler: function ()
      {
        this.$emit('del_items')
      },
      deep: true
    }
  },
  mounted()
  {
    this.cartItem = JSON.parse(JSON.stringify(this.item))
  },
  props:['item']
}
</script>

<style scoped>
.img
{
  width: 100%;
}
.input-number {
  width: 40%;
  vertical-align: top;
  text-align: center;
  outline: none;
  padding: 0;
}

.input-number,
.input-number-decrement,
.input-number-increment
{
  border: 1px solid #ccc;
  height: 40px;
  user-select: none;
}

.input-number-decrement,
.input-number-increment
{
  display: inline-block;
  width: 30%;
  line-height: 38px;
  background: #f1f1f1;
  color: #444;
  text-align: center;
  font-weight: bold;
  cursor: pointer;}


.input-number-decrement
{
  border-right: none;
  border-radius: 0 4px 4px 0;
}

.input-number-increment
{
  border-left: none;
  border-radius: 4px 0 0 4px;
}
.position-relative
{
  position: relative;
}
.del_btn{
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  display: block;
  z-index: 3;
}
.justify-between
{
  display: flex;
  justify-content: space-between;
}
.percent {
  background: #eb445a;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 3px;
}
.mb-1
{
  margin-bottom: 5px;
}
</style>